import {connect} from 'react-redux';
import {ActionCreatorsMapObject, bindActionCreators, Dispatch} from 'redux';

import {GlobalState} from 'types/store/index';

import {ModalData} from 'types/actions';
import {openModal} from 'actions/views/modals';
import {setShowPreviewOnCreatePost, setShowPreviewOnEditChannelHeaderModal, setShowPreviewOnCreateComment} from 'actions/views/textbox';
import {showPreviewOnCreatePost, showPreviewOnCreateComment, showPreviewOnEditChannelHeaderModal} from 'selectors/views/textbox';
import {getCurrentLocale} from 'selectors/i18n';

import {isFeatureEnabled} from 'utils/utils';

import Constants from 'utils/constants';

import {TextboxMoreButton} from './textbox_more_button';

type Actions = {
    setShowPreview: (showPreview: boolean) => void;
    openModal: <P>(modalData: ModalData<P>) => void;
}

// Create post

function mapPostStateToProps(state: GlobalState) {
    const newEditorEnabled = isFeatureEnabled(Constants.PRE_RELEASE_FEATURES.NEW_EDITOR, state);

    return {
        shouldShowPreview: showPreviewOnCreatePost(state),
        locale: getCurrentLocale(state),
        newEditorEnabled,
    };
}

function mapPostDispatchToProps(dispatch: Dispatch) {
    return {
        actions: bindActionCreators<ActionCreatorsMapObject, Actions>({
            openModal,
            setShowPreview: setShowPreviewOnCreatePost,
        }, dispatch),
    };
}

export const CreatePostMoreButton = connect(mapPostStateToProps, mapPostDispatchToProps)(TextboxMoreButton);

// Create comment

function mapCommentStateToProps(state: GlobalState) {
    const newEditorEnabled = isFeatureEnabled(Constants.PRE_RELEASE_FEATURES.NEW_EDITOR, state);

    return {
        shouldShowPreview: showPreviewOnCreateComment(state),
        locale: getCurrentLocale(state),
        newEditorEnabled,
    };
}

function mapCommentDispatchToProps(dispatch: Dispatch) {
    return {
        actions: bindActionCreators<ActionCreatorsMapObject, Actions>({
            openModal,
            setShowPreview: setShowPreviewOnCreateComment,
        }, dispatch),
    };
}
export const CreateCommentMoreButton = connect(mapCommentStateToProps, mapCommentDispatchToProps)(TextboxMoreButton);

// Edit channel header

function mapEditChannelHeaderStateToProps(state: GlobalState) {
    return {
        shouldShowPreview: showPreviewOnEditChannelHeaderModal(state),
        locale: getCurrentLocale(state),
    };
}

function mapEditChannelHeaderDispatchToProps(dispatch: Dispatch) {
    return {
        actions: bindActionCreators<ActionCreatorsMapObject, Actions>({
            openModal,
            setShowPreview: setShowPreviewOnEditChannelHeaderModal,
        }, dispatch),
    };
}
export const EditChannelHeaderMoreButton = connect(mapEditChannelHeaderStateToProps, mapEditChannelHeaderDispatchToProps)(TextboxMoreButton);
